import { render, staticRenderFns } from "./Expand.vue?vue&type=template&id=536443de&"
import script from "./Expand.vue?vue&type=script&lang=js&"
export * from "./Expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports